import { Card, Group, SimpleGrid, Stack, Text, ThemeIcon } from "@mantine/core";
import { CAMPAIGN_TEMPLATES } from "./campaignTemplates";

// Card picker for starting a campaign from a template. Selecting a card
// pre-fills the campaign. The heading is shown when used inline; in a modal the
// modal title already labels it, so pass showHeading={false}.
const TemplatePicker = ({ onSelect, showHeading = true }) => {
  return (
    <Stack gap="sm">
      {showHeading && <Text fw={500}>Start from a template</Text>}
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
        {CAMPAIGN_TEMPLATES.map((template) => {
          const Icon = template.icon;
          return (
            <Card
              key={template.id}
              withBorder
              shadow="sm"
              padding="md"
              radius="md"
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
              onClick={() => onSelect(template)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelect(template);
                }
              }}
            >
              <Stack gap="xs">
                <Group gap="xs" wrap="nowrap">
                  {Icon && (
                    <ThemeIcon
                      variant="light"
                      size="lg"
                      radius="md"
                      color={template.color}
                    >
                      <Icon size={20} stroke={1.5} />
                    </ThemeIcon>
                  )}
                  <Text fw={600}>{template.name}</Text>
                </Group>
                <Text size="sm" c="dimmed">
                  {template.description}
                </Text>
              </Stack>
            </Card>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};

export default TemplatePicker;
